"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuotaManager = void 0;
var dequeue_1 = require("../dequeue");
/** keep track of API invocations, allowing or disallowing them based on our quota */
var QuotaManager = /*#__PURE__*/function () {
  function QuotaManager(_quota) {
    _classCallCheck(this, QuotaManager);
    this._quota = _quota;
    this._activeCount = 0;
    this.history = new dequeue_1.Dequeue();
    if (typeof _quota !== 'object') {
      console.warn('[p-ratelimit QuotaManager] A QuotaManager was created with no quota.');
      this._quota = {};
    }
    if ('interval' in this._quota && !('rate' in this._quota) || 'rate' in this._quota && !('interval' in this._quota)) {
      var msg = "[p-ratelimit QuotaManager] Invalid Quota: for a rate-limit quota, both " + "interval and rate must be specified.";
      throw new Error(msg);
    }
  }
  /** The current quota */
  _createClass(QuotaManager, [{
    key: "quota",
    get: function get() {
      return Object.assign({}, this._quota);
    }
    /** The number of currently-active invocations */
  }, {
    key: "activeCount",
    get: function get() {
      return this._activeCount;
    }
    /** Max amount of time a queued request can wait before throwing a timeout error */
  }, {
    key: "maxDelay",
    get: function get() {
      return this._quota.maxDelay || 0;
    }
    /**
     * Log that an invocation started.
     * @returns true if the invocation was allowed, false if not (you can try again later)
     */
  }, {
    key: "start",
    value: function start() {
      if (this._activeCount >= this._quota.concurrency) {
        return false;
      }
      if (this._quota.interval !== undefined && this._quota.rate !== undefined) {
        this.removeExpiredHistory();
        if (this.history.length >= this._quota.rate) {
          return false;
        }
        this.history.push(Date.now());
      }
      this._activeCount++;
      return true;
    }
    /** Log that an invocation ended */
  }, {
    key: "end",
    value: function end() {
      this._activeCount--;
    }
  }, {
    key: "removeExpiredHistory",
    value: function removeExpiredHistory() {
      var expired = Date.now() - this._quota.interval;
      while (this.history.length && this.history.peekFront() < expired) {
        this.history.shift();
      }
    }
  }]);
  return QuotaManager;
}();
exports.QuotaManager = QuotaManager;